module.exports = __webpack_public_path__ + "img/user.afcc9b05.svg";